import { EInvoiceHistoryStatus } from '../../../data/model'
import { StatusTag } from './StatusTag'

export const statusBodyTemplate = (status?: EInvoiceHistoryStatus) => {
  return <StatusTag status={status} />
}
